<template>
  <menu-scroll-lock
    v-if="isSignedIn && (loadPendingOrdersStatus.pending || pendingOrders.length)"
    offset-y
    v-model="show"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs" v-on="on"
        :text="text" :disabled="disabled" :color="color" :loading="loading || loadPendingOrdersStatus.pending"
      >
        <slot>Add to card</slot>
        <v-icon class="menu-down mr-n1" v-html="mdiMenuDown" />
      </v-btn>
    </template>
    <v-list class="py-0 grey lighten-5 overflow-auto">
      <div class="text--label-active pa-2">Create new project</div>
      <cart-list-item class="pl-0" order-id="new" :order="preview" @click="$emit('select', 'new', null)">
        <div class="ec-dark-blue--text font-weight-bold text-body-2">Create new project</div>
      </cart-list-item>
      <div class="text--label-active pa-2">Add to saved project</div>
      <cart-list-item
        v-for="[ orderId, order ] in pendingOrders" :key="orderId"
        class="pl-0"
        :order-id="orderId"
        :order="order"
        @click="$emit('select', orderId, order)"
      />
    </v-list>
  </menu-scroll-lock>

  <v-btn
    v-else
    :text="text" :disabled="disabled" :color="color" :loading="loading"
    @click="$emit('select', 'new', null)"
  >
    <slot>Add to card</slot>
  </v-btn>
</template>

<script>
import CartListItem from '@/components/CartListItem.vue';
import MenuScrollLock from '@/components/MenuScrollLock.vue';
import pendingOrders from '@/mixins/pending-orders.js';
import { mdiMenuDown } from '@mdi/js';

export default {
  name: 'add-to-project-btn',

  mixins: [ pendingOrders ],

  components: {
    CartListItem,
    MenuScrollLock
  },

  props: [ 'text', 'disabled', 'preview', 'color', 'loading' ],

  data() {
    return {
      show: false
    };
  },

  created() {
    Object.assign(this, { mdiMenuDown });
  },

  watch: {
    isSignedIn: {
      immediate: true,
      handler() {
        this.loadPendingOrders();
      }
    }
  }
}
</script>
